"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = make;

require("poor-mans-proxy");

//proxy object
//If object key is undefined, just return key name.
var handler = {
  get: function get(target, name) {
    return name in target ? target[name] : name;
  }
};

function make(obj) {
  return new Proxy(obj, handler);
}
//# sourceMappingURL=undefinedToKey.js.map